import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiBookOpen, FiCheck, FiHeart, FiLoader, FiMaximize2, FiSmartphone, FiStar } from "react-icons/fi";
import useCurrencyStore from "store/currencyStore";
import useAddToWishlist from "api/wishlistResource/useAddToWishlist";
import useRemoveFromWishlist from "api/wishlistResource/useRemoveFromWishlist";
import { catalogueBookDetails, catalogueBookPath, enabled } from "./catalogueBookDetails";
import CatalogueCover from "./CatalogueCover";

export default function CatalogueBookCard({ book, showWishlist, onTagClick, onQuickLook }) {
	const location = useLocation();
	const currency = useCurrencyStore((state) => state.currency);
	const [saved, setSaved] = useState(enabled(book.in_wishlist));
	const add = useAddToWishlist();
	const remove = useRemoveFromWishlist();
	useEffect(() => { setSaved(enabled(book.in_wishlist)); }, [book.in_wishlist]);
	const { free, price, inLibrary, format } = catalogueBookDetails(book, currency);
	const FormatIcon = book.format === "digital" ? FiSmartphone : FiBookOpen;
	const rating = Number(book.rating);
	const tags = Array.isArray(book.tags) ? book.tags.map((tag) => typeof tag === "string" ? tag : tag?.name).filter(Boolean).slice(0, 2) : [];
	const busy = add.isLoading || remove.isLoading;
	const toggleSaved = async () => {
		try {
			await (saved ? remove.mutateAsync(book.id) : add.mutateAsync(book.id));
			setSaved(!saved);
		} catch { /* The existing mutation displays the server error. */ }
	};
	return (
		<article className={`catalogue-book${showWishlist ? " has-save" : ""}${tags.length ? " has-tags" : ""}`}>
			<Link to={catalogueBookPath(book, location)} className="catalogue-book-link" aria-label={`${book.title}${book.author ? ` by ${book.author}` : ""}. ${price}`}>
				<div className="catalogue-book-cover">
					<CatalogueCover book={book} />
				</div>
				<div className="catalogue-book-body">
					<div className="catalogue-book-meta">
						<span>{book.category?.name || "Book"}</span>
						{rating > 0 && rating <= 5 && <span className="catalogue-book-rating" aria-label={`${rating.toFixed(1)} out of 5 stars`}><FiStar aria-hidden="true" />{rating.toFixed(1)}</span>}
					</div>
					<h3 title={book.title}>{book.title}</h3>
					<p className="catalogue-book-author" title={book.author}>{book.author || "Author not listed"}</p>
					<div className="catalogue-book-format">
						{format && <span><FormatIcon aria-hidden="true" />{format}</span>}
						{showWishlist && inLibrary ? <span className="catalogue-access"><FiCheck aria-hidden="true" />In your library</span> : free && <span className="catalogue-access">Free to read</span>}
						{enabled(book.has_preview) && <span>Preview available</span>}
					</div>
					<div className="catalogue-book-bottom"><strong>{price}</strong></div>
				</div>
			</Link>
			{showWishlist && (
				<button type="button" className="catalogue-save" onClick={toggleSaved} disabled={busy} aria-pressed={saved} aria-label={`${saved ? "Remove from" : "Add to"} wishlist: ${book.title}`} title={saved ? "Remove from wishlist" : "Save to wishlist"}>
					{busy ? <FiLoader className="catalogue-spin" aria-hidden="true" /> : <FiHeart aria-hidden="true" fill={saved ? "currentColor" : "none"} />}
				</button>
			)}
			{onQuickLook && (
				<button type="button" className="catalogue-peek" onClick={() => onQuickLook(book.id)} aria-haspopup="dialog" aria-label={`Quick look: ${book.title}`} title="Quick look">
					<span>Quick look</span><FiMaximize2 aria-hidden="true" />
				</button>
			)}
			{tags.length > 0 && <div className="catalogue-book-tags" aria-label={`Tags for ${book.title}`}>{tags.map((tag) => <button key={tag} type="button" onClick={() => onTagClick(tag)} aria-label={`Filter by tag ${tag}`}>{tag}</button>)}</div>}
		</article>
	);
}
